<template>
    <transition name="fade">
        <div v-if="show" class="popup_overlay" :class="positionClass">
            <div class="popUp_content" :style="{ backgroundColor: popupBackgroundColor  }">
                <div class="popUp_body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { computed, watch } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        required: true,
    },
    position: {
        type: String,
        default: 'center',
    },
    popupBackgroundColor : {
        type: String,
        default: 'black', 
    },
    duration: {
        type: Number,
        default: 5000,
    }
});

const emit = defineEmits(['update:show']);  

const positionClass = computed(() => {
    switch (props.position) {
        case 'left':
            return 'popup_left';
        case 'right':
            return 'popup_right';
        default: 
            return 'popup_center';
    }
});

// Surveiller `show` et fermer automatiquement après `duration`
watch(() => props.show, (newVal) => {
    if (newVal && props.duration > 0) {
        setTimeout(() => {
            emit('update:show', false);
        }, props.duration);
    }
});
</script>

<style scoped lang="scss">
    .popup_overlay {
        position: fixed;
        top: -500px;
        left: 0;
        right: 0;
        bottom: 0;
        // background-color: rgba(255, 255, 255, 0.4);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100000;
    }

    .popup_center {
        justify-content: center;
        align-items: center;
    }

    .popup_left {
        justify-content: flex-start;
    }

    .popup_right {
        justify-content: flex-end;
    }

    .popUp_content {
    padding: 20px;
    border-radius: 8px;
    max-width: 400px;
    width: 90%;
    position: relative;
    max-height: 80vh;
    overflow-y: auto;
    }

    .popUp_body {
        padding: 20px;
        text-align: center;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease, transform 0.5s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
        transform: scale(0.8);  // Réduit légèrement le pop-up pour un effet doux
    }
</style>
